export default __webpack_public_path__ + "static/media/history_1990_00.e52c673a.png";